import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useMediaQuery, useTheme } from '@mui/material'
import { useMobileNav } from '@hooks/useMobileNav'

/** True when the app shell uses a temporary nav drawer (flag on and viewport below `md`). */
export function useTemporaryAppDrawer(): boolean {
  const mobileNav = useMobileNav()
  const theme = useTheme()
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })
  return mobileNav && !isMdUp
}

export function useAppShellDrawerState() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()
  const isTemporaryDrawer = useTemporaryAppDrawer()

  useEffect(() => {
    setMobileOpen(false)
  }, [location.key])

  useEffect(() => {
    if (!isTemporaryDrawer) {
      setMobileOpen(false)
    }
  }, [isTemporaryDrawer])

  useEffect(() => {
    if (!isTemporaryDrawer || !mobileOpen) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMobileOpen(false)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [isTemporaryDrawer, mobileOpen])

  const toggleMobileDrawer = () => setMobileOpen((open) => !open)
  const closeMobileDrawer = () => setMobileOpen(false)

  return {
    mobileOpen,
    toggleMobileDrawer,
    closeMobileDrawer,
    isTemporaryDrawer,
  }
}
